import React from 'react';
import Logo from '../assets/logo.png';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <>
      <footer className='footer-sec py-5' style={{backgroundColor:'var(--ins1)',}}>
        <div className='container'>

          <div className='d-flex'>
            <img src={Logo} className='footer-logo bg-white rounded-circle' alt='Logo' />
            <div className='align-content-center ms-2 text-light'>
              <p className='fs-5 fw-bold my-0'>KC Public School</p>
              <hr className='text-light opacity-100 my-2' />
              <span className='para-text'>Better Students for A Better Tomorrow</span></div>
          </div>


          <div className='row mt-4'>

            <div className='col-lg-4 col-md-6 col-12 my-2'>
              <p className='footer-heading'>Get in touch with us </p>
              <p className='footer-text'>K. C. Trust is a non-profit, educational body widely recognized for its commitment to excellence in education.</p>
              <p className='footer-text'>Start your child’s educational journey with us! Enquire today to learn more about our admissions process, programs, and how we nurture academic excellence and holistic development.</p>
              
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-2'>
              <p className='footer-heading'>Quick Links</p>
              <p className='footer-text' onClick={() => navigate('/')}><i class="fa-solid fa-angles-right"></i> Home</p>
              <p className='footer-text' onClick={() => navigate('/about')}><i class="fa-solid fa-angles-right"></i> About</p>
              <p className='footer-text' onClick={() => navigate('/academics')}><i class="fa-solid fa-angles-right"></i> Academics</p>
              <p className='footer-text' onClick={() => navigate('/')}><i class="fa-solid fa-angles-right"></i> Posts</p>
              <p className='footer-text' onClick={() => navigate('/contact')}><i class="fa-solid fa-angles-right"></i> Contact</p>
              <p className='footer-text' onClick={() => navigate('/privacy-policy')}><i class="fa-solid fa-angles-right"></i> Privacy Policy</p>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-2'>
    <button className='btn text-light fw-semibold me-2' style={{backgroundColor: 'var(--ins4)'}} onClick={() => window.open('/institute-login', '_blank')}>Institute Login</button>
                  <button className='btn text-light fw-semibold' style={{backgroundColor: 'var(--ins4)'}} onClick={() => window.open('/staff-login', '_blank')}>Staff Login</button>

              <p className='footer-text mt-3'><i class="fa-solid fa-map-location-dot"></i> Kamapalli Main Rd, near to Tata Benz, Chhak, Kamapalli, Berhampur, Odisha 760004</p>
              <p className='footer-text'><Link className='text-light text-decoration-none' to='tel:6802221154'><i class="fa-solid fa-phone"></i> 0680 222 1154</Link></p>
              <p className='footer-text'><Link className='text-light text-decoration-none' to='mailto:kcpublicschool@gmail.com'><i class="fa-solid fa-envelope-open-text"></i> kcpublicschool@gmail.com</Link></p>
              <p className='footer-text'>&copy; Copyright KC Public School. All Rights Reserved.<br />
                <Link className='text-light text-decoration-none' to='https://www.digithack.in/' target='_blank' >Developed By Digit Hack Software Solutions</Link></p>
            </div>

          </div>
          {/* row ends */}

        </div>
      </footer>
    </>
  )
}

export default Footer